import useBeerImageUrl from "hooks/use-beer-image-url";
import { Beer } from "store/reducers/beers/reducer";
import {
  Body,
  BottleColumn,
  BottleImage,
  Card,
  Name,
  Para,
  RoundChip,
} from "./beer-card.styles";

export type BeerCardProps = {
  beer: Beer;
  round?: number;
};

const hasNotes = (beer: Beer): boolean =>
  Boolean(beer?.mouthfeel || beer?.taste || beer?.smell || beer?.appearance);

const Note = ({ label, text }: { label: string; text?: string }) => {
  if (!text) return null;
  return (
    <Para>
      <span className="label">{label}</span>
      {` — ${text}`}
    </Para>
  );
};

const BeerCard = ({ beer, round }: BeerCardProps) => {
  // Image URLs resolve lazily as the card scrolls into view — the list
  // itself never waits on (or bulk-fires) Storage requests.
  const [cardRef, imageUrl] = useBeerImageUrl(beer);
  return (
    <Card ref={cardRef}>
      <BottleColumn>
        <BottleImage beer={beer} imageUrl={imageUrl} />
        {round != null && <RoundChip>Round {round}</RoundChip>}
      </BottleColumn>
      <Body>
        <Name>{beer.displayName}</Name>
        {hasNotes(beer) && (
          <>
            <Note label="Appearance" text={beer.appearance} />
            <Note label="Smell" text={beer.smell} />
            <Note label="Taste" text={beer.taste} />
            <Note label="Mouthfeel" text={beer.mouthfeel} />
          </>
        )}
      </Body>
    </Card>
  );
};

export default BeerCard;
